import styled from 'styled-components';

export const Container = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  height: '100%',

  overflow: 'hidden',
}));

export const PricingContainer = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'flex-end',

  height: '100%',
  minInlineSize: '100rem',
  borderInlineStart: `1rem solid ${theme.header.primaryAccent.text}`,
  paddingInlineStart: '25rem',
}));
